// Random hero image selection and fade in
import { HERO_IMAGES } from '../config/heroImages.js';

(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        if (!HERO_IMAGES || HERO_IMAGES.length === 0) {
            console.warn('No hero images configured in heroImages.js');
            return;
        }

        // Pick two different random images
        let heroIndex, flagshipIndex;
        
        if (HERO_IMAGES.length === 1) {
            // If only one image, use it for both
            heroIndex = HERO_IMAGES[0];
            flagshipIndex = HERO_IMAGES[0];
        } else {
            // Pick random image for hero
            heroIndex = HERO_IMAGES[Math.floor(Math.random() * HERO_IMAGES.length)];
            
            // Pick different image for flagship
            let availableImages = HERO_IMAGES.filter(i => i !== heroIndex);
            flagshipIndex = availableImages[Math.floor(Math.random() * availableImages.length)];
        }

        // Set up hero background
        const heroWrapper = document.querySelector('.hero_background_wrapper');
        const heroPicture = heroWrapper?.querySelector('picture');
        
        if (heroPicture && heroWrapper) {
            const paddedIndex = String(heroIndex).padStart(2, '0');
            
            const avifSource = heroPicture.querySelector('source[type="image/avif"]');
            const webpSource = heroPicture.querySelector('source[type="image/webp"]');
            const img = heroPicture.querySelector('img');
            
            if (avifSource) avifSource.srcset = `/assets/images/hero_${paddedIndex}.avif`;
            if (webpSource) webpSource.srcset = `/assets/images/hero_${paddedIndex}.webp`;
            if (img) {
                img.src = `/assets/images/hero_${paddedIndex}.jpg`;
                
                if (img.complete) {
                    setTimeout(() => heroWrapper.classList.add('loaded'), 300);
                } else {
                    img.addEventListener('load', function() {
                        setTimeout(() => heroWrapper.classList.add('loaded'), 300);
                    });
                }
            }
        }

        // Set up flagship background
        const flagshipWrapper = document.querySelector('.flagship_background_wrapper');
        const flagshipPicture = flagshipWrapper?.querySelector('picture');
        
        if (flagshipPicture && flagshipWrapper) {
            const paddedIndex = String(flagshipIndex).padStart(2, '0');
            
            const avifSource = flagshipPicture.querySelector('source[type="image/avif"]');
            const webpSource = flagshipPicture.querySelector('source[type="image/webp"]');
            const img = flagshipPicture.querySelector('img');
            
            if (avifSource) avifSource.srcset = `/assets/images/hero_${paddedIndex}.avif`;
            if (webpSource) webpSource.srcset = `/assets/images/hero_${paddedIndex}.webp`;
            if (img) {
                img.src = `/assets/images/hero_${paddedIndex}.jpg`;
                
                if (img.complete) {
                    setTimeout(() => flagshipWrapper.classList.add('loaded'), 300);
                } else {
                    img.addEventListener('load', function() {
                        setTimeout(() => flagshipWrapper.classList.add('loaded'), 300);
                    });
                }
            }
        }
    });
})();
